var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","total":_vm.pageData.total,"page-size":_vm.pageData.pageSize,"current":_vm.pageData.current},on:{"current-change":_vm.changePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }